import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BulkUpdateComponent } from './bulk-update.component';
import { ListModule } from './list';
import { EditModule } from './edit';
import { EventListModule } from './event-list';

const ROUTES: Routes = [
  {
    path: '',
    component: BulkUpdateComponent,
    loadChildren: (): any => ListModule,
    pathMatch: 'full',
  },
  {
    path: 'new',
    component: BulkUpdateComponent,
    loadChildren: (): any => EditModule,
    pathMatch: 'full',
  },
  {
    path: ':id',
    component: BulkUpdateComponent,
    loadChildren: (): any => EventListModule,
    pathMatch: 'full',
  },
];

@NgModule({ imports: [
  CommonModule,
  FormsModule,
  RouterModule.forChild(ROUTES),
],
declarations: [BulkUpdateComponent],
exports: [BulkUpdateComponent],
providers: [] })
export class BulkUpdateModule {}
